import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import api from '../../config/axios';
import ertinuLogo from '../../assets/images/ertinu_logo.png';
import aproLogo from '../../assets/images/apro_logo.png';
import loginGif from '../../assets/images/customer-service-210630.png';
// LoadingDots component removed as it's not used

const CustomerLoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Domain kontrolü ile logo seçimi
  const getLogoByDomain = () => {
    const hostname = window.location.hostname;
    if (hostname.includes('ertinu.com')) {
      return ertinuLogo;
    } else {
      return aproLogo; // localhost, apro.com.tr ve diğer tüm durumlar için
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      
      const response = await api.post('/auth/customer-login', { 
        username, 
        password 
      });

      // Yapay gecikme ekleyelim (0.5 saniye)
      await new Promise(resolve => setTimeout(resolve, 500));


      if (response.data.token) {
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('user', JSON.stringify(response.data.user));
        navigate('/customer-dashboard');
      }
    } catch (err) {
      console.error('Login error:', err);
      
      // More detailed error logging
      if (err.response) {
        console.error('Error response:', {
          data: err.response.data,
          status: err.response.status
        });
        setError(err.response.data.message || 'Giriş yapılamadı. Lütfen bilgilerinizi kontrol edin.');
      } else if (err.request) {
        console.error('Error request:', err.request);
        setError('Sunucuya bağlanılamadı. Lütfen internet bağlantınızı kontrol edin.');
      } else {
        console.error('Error message:', err.message);
        setError('Giriş işlemi sırasında bir hata oluştu.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col lg:flex-row h-screen">
      {/* Sol Panel - Müşteri Login Formu (Mobilde tam genişlik) */}
      <div className="w-full lg:w-[500px] bg-[#272c39] h-full flex flex-col px-6 sm:px-8 lg:px-12">
        <div className="mt-8 sm:mt-12 lg:mt-20 mb-8 sm:mb-12 lg:mb-16 flex justify-start w-full">
          <img src={getLogoByDomain()} alt="Company Logo" className="h-10 sm:h-12" />
        </div>

        <div className="w-full">
          <h2 className="text-xl sm:text-2xl font-medium text-white mb-2">Customer Support Portal</h2>
          <p className="text-white/60 text-sm mb-6 sm:mb-8">Please enter your credentials</p>

          {location.state?.message && (
            <div className="bg-yellow-500/10 text-yellow-400 text-xs sm:text-sm p-3 rounded-md mb-4">
              {location.state.message}
            </div>
          )}

          {/* Form Elemanları - Mobilde daha rahat dokunma alanları */}
          <form onSubmit={handleSubmit} className="space-y-4 sm:space-y-6">
            <div>
              <label className="block text-sm font-medium text-white/80 mb-1.5">
                Username
              </label>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="w-full px-3 py-2.5 sm:py-2 bg-white/10 border border-white/10 text-white rounded-md 
                  focus:outline-none focus:ring-2 focus:ring-white/20 focus:border-transparent
                  placeholder-white/30 text-base"
                required
                disabled={loading}
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-white/80 mb-1.5">
                Password
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-3 py-2.5 sm:py-2 bg-white/10 border border-white/10 text-white rounded-md 
                  focus:outline-none focus:ring-2 focus:ring-white/20 focus:border-transparent
                  placeholder-white/30 text-base"
                required
                disabled={loading}
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className={`w-full py-2.5 sm:py-2 rounded-md transition-all font-medium flex items-center justify-center
                disabled:cursor-not-allowed text-base ${
                loading 
                  ? 'bg-transparent' 
                  : 'bg-white text-[#272c39] hover:bg-white/90'
              }`}
            >
              {loading ? (
                <div className="flex space-x-1">
                  <div className="w-1.5 h-1.5 bg-white rounded-full animate-[loading_0.9s_ease-in-out_infinite]" />
                  <div className="w-1.5 h-1.5 bg-white rounded-full animate-[loading_0.9s_ease-in-out_0.3s_infinite]" />
                  <div className="w-1.5 h-1.5 bg-white rounded-full animate-[loading_0.9s_ease-in-out_0.6s_infinite]" />
                </div>
              ) : (
                'Sign In'
              )}
            </button>

            {/* Navigation Links - Sol ve sağ hizalı */}
            <div className="flex justify-between">
              <button 
                type="button"
                className="text-sm text-white/50 hover:text-white/90 transition-colors"
                onClick={() => navigate('/admin')}
              >
                Agent Login
              </button>
              <button 
                type="button"
                className="text-sm text-white/50 hover:text-white/90 transition-colors"
                onClick={() => navigate('/forgot-password')}
              >
                Forgot Password
              </button>
            </div>

            {error && (
              <div className="bg-red-500/10 text-red-400 text-sm p-3 rounded-md mt-4">
                {error}
              </div>
            )}
          </form>
        </div>

        <div className="mt-auto mb-6 sm:mb-8 text-center w-full">
          <p className="text-white/40 text-xs sm:text-sm">
            {window.location.hostname.includes('ertinu.com') 
              ? '© 2024 ERTINU. All rights reserved.'
              : '© 2024 APRO. All rights reserved.'
            }
          </p>
        </div>
      </div>

      {/* Sağ Panel - Görsel ve Açıklama (Sadece geniş ekran) */}
      <div className="hidden lg:flex flex-1 bg-[#f5f7f9] flex-col items-center justify-center">
        <div className="max-w-[600px] text-center">
          <img 
            src={loginGif} 
            alt="Conversation Animation" 
            className="mx-auto max-h-[400px] object-contain mb-8"
          />
          <div className="text-center px-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-2">
              Support at Your Fingertips!
            </h2>
            <p className="text-lg text-gray-600">
              Log in to find quick and effective solutions to your issues. Manage your support requests, track SLA statuses, and connect directly with our team.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerLoginPage; 